import { render, staticRenderFns } from "./30.vue?vue&type=template&id=1d2c0d4e&scoped=true&"
import script from "./30.vue?vue&type=script&lang=js&"
export * from "./30.vue?vue&type=script&lang=js&"
import style0 from "./30.vue?vue&type=style&index=0&id=1d2c0d4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2c0d4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d2c0d4e')) {
      api.createRecord('1d2c0d4e', component.options)
    } else {
      api.reload('1d2c0d4e', component.options)
    }
    module.hot.accept("./30.vue?vue&type=template&id=1d2c0d4e&scoped=true&", function () {
      api.rerender('1d2c0d4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/details/30.vue"
export default component.exports